import { StandingOrderCardInfoDropdown } from "./StandingOrderCardInfoDropdown";

export default StandingOrderCardInfoDropdown;
